module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "landing-transition",
      "enter-active-class": "animated slideInDown",
      "leave-active-class": "animated slideOutUp"
    }
  }, [_c('div', {
    staticClass: "landing",
    attrs: {
      "data-size": "lg"
    }
  }, [(_vm.hasSupport) ? _c('div', {
    staticClass: "content"
  }, [(!_vm.has404) ? _c('h1', [_vm._v(_vm._s(_vm.landing.title))]) : _vm._e(), _vm._v(" "), (!_vm.has404) ? _c('h2', [_vm._v(_vm._s(_vm.landing.tagline))]) : _vm._e(), _vm._v(" "), (_vm.has404) ? _c('h1', [_vm._v(_vm._s(_vm.status.err404.title))]) : _vm._e(), _vm._v(" "), (_vm.has404) ? _c('h2', [_vm._v(_vm._s(_vm.status.err404.msg))]) : _vm._e(), _vm._v(" "), _c('progress-button', {
    attrs: {
      "method": _vm.openSesame,
      "loadingLabel": _vm.loadingLabel,
      "readyLabel": _vm.buttonLabel
    }
  })], 1) : _c('div', {
    staticClass: "content unsupported"
  }, [_c('h1', [_vm._v(_vm._s(_vm.unsupported.heading))]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.unsupported.msg))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0516318a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Landing.vue
// module id = 442
// module chunks = 1